export const iconFontAwesomeMedicalHealthHandHoldingDroplet = (
	<i className="fa-solid fa-hand-holding-droplet"></i>
);
